import Page from 'components/shared/Page';
import { observer } from 'mobx-react';
import React, { FC, useState, useCallback } from 'react';
import Grid from 'components/UI/Grid';
import styled from 'styled-components';
import { TabPanel, TabView, TabViewTabChangeEvent } from 'primereact/tabview';
import { useTranslation } from 'react-i18next';
import CampaignsTab from './CampaignsTab';

const TabViewContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 1rem;
`;

export const TreeContainer = styled.div`
  height: calc(100vh - 106px);
  margin: 1rem;
  margin-right: 0;
  overflow: hidden;
`;

const Campaigns: FC = observer(() => {
  const { t } = useTranslation('campaigns');
  const [isLoading, setIsLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState<number>(
    0
  );

  const onTabChange = useCallback((e: TabViewTabChangeEvent) => {
    setActiveIndex(e.index);
  }, []);

  return (
    <Page>
      <Grid direction="column" align="stretch" justify="start" grow>
        <TabViewContainer>
          <TabView
            activeIndex={activeIndex}
            renderActiveOnly={false}
            onTabChange={onTabChange}
          >
            <TabPanel header={t('campaigns')}>
              <CampaignsTab />
            </TabPanel>
          </TabView>
        </TabViewContainer>
      </Grid>
    </Page>
  );
});

export default Campaigns;
